import { ItemList } from '../../orm'
import { download } from '../../actions/lib'

class AdminCustomerReportList extends ItemList {
    getEntityKey() {
        return "admin/customer_report/generate"
    }

    createCreditsReport({filter}) {
        return this.saveNewObject({filter:filter, report_type: 'credits'})
    }

    createListReport({filter}) {
        return this.saveNewObject({filter:filter, report_type: 'list'})
    }

}

export const adminCustomerReportList = new AdminCustomerReportList("admin_customer_report__default")
